"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _types = require("./types");
Object.keys(_types).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _types[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _types[key];
        }
    });
});
var _Button = require("./Button");
Object.keys(_Button).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _Button[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _Button[key];
        }
    });
});
